export default "__VITE_ASSET__kNDRbUwh__"